import classNames from "classnames";
import classes from "./CareerOffer.module.scss";
import { ComponentPropsWithoutRef } from "react";
import { useTranslation } from "next-i18next";
import { Button, Col } from "react-bootstrap";
import TranslatedLink from "components/utilities/TranslatedLink";

interface Props extends ComponentPropsWithoutRef<"div"> {}

const CareerOffer = ({ ...htmlProps }: Props) => {
  const { t } = useTranslation("history");

  return (
    <div className={classes.careerOffer} {...htmlProps}>
      <Col
        className={classes.careerOffer__container}
        sm={6}
        md={4}
        xl={3}
        xxl={2}
      >
        <div>
          <p className={classes.careerOffer__textation}>
            {t("career-offer.offer")}
          </p>
        </div>
        <TranslatedLink href="/career#careerContactForm">
          <Button variant="outline-secondary bg-info border-0 my-2 text-white">
            <p className="my-1 text-white">{t("career-offer.career-button")}</p>
          </Button>
        </TranslatedLink>
      </Col>
    </div>
  );
};

export default CareerOffer;
